(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-review"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function() {
  jQuery('.star-rating .star-display').each(function() {
    var rating = parseInt(jQuery(this).data('rating'));
    jQuery(this).html(generateStarRating(rating));
  });

  function generateStarRating(rating) {
    var stars = '';
    for (var i = 1; i <= 5; i++) {
      if (i <= rating) {
        stars += '<svg class="star filled" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2L9.09 8.36 2 9.27l5.46 4.73L6.55 22 12 17.77l5.46 4.73-1.61-8.64L22 9.27l-7.09-1.12z"/></svg>';
      } else {
        stars += '<svg class="star" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 17.27l-5.46 4.73 1.64-7.15L2.29 9.77l7.21-.86L12 2l2.5 6.91 7.21.86-5.89 5.08 1.64 7.15z"/></svg>';
      }
    }
    return stars;
  }
});

  } catch(e) { console.error(e); }
})();
})();
